export enum EmailBasketFieldKeys {
  Account = 'account',
  Recipient = 'recipient',
  Email = 'email',
  Name = 'name',
  Message = 'message',
  ShouldCreateBasket = 'shouldCreateBasket',
  ShouldReuseBasket = 'shouldReuseBasket',
}
